import { useSwrMutationApi } from '@hooks/useSwrApi';

interface TTSRequestBody {
  text: string;
  language: Locale;
}

interface UseSwrTextToSpeechProps {
  locale?: Locale;
  onSuccess?: (audioStream: unknown) => void;
}

const TTS_API = `${process.env.NEXT_PUBLIC_MATCHING_URL}/common/tts`;

/**
 * @description Hook for fetching text-to-speech audio stream.
 * - `locale`: The current app locale.
 * - `onSuccess`: Optional callback to execute on success.
 */
export const useSwrTextToSpeech = (props: UseSwrTextToSpeechProps) => {
  const { locale, onSuccess } = props;

  return useSwrMutationApi<unknown, TTSRequestBody>({
    url: TTS_API,
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess,
    },
    toastsOptions: {
      showSuccessToast: false,
      showErrorToast: false,
    },
  });
};
